import { TableCell, Typography } from '@material-ui/core'
import { SortingOrder } from 'shared/types'
import { Content, IconButton, ArrowDropDown } from './TableHeadCell.style'

interface TableHeadCellProps {
  title: string
  order?: SortingOrder
  element?: JSX.Element
  handleSort?: (order: SortingOrder) => void
}

const Table = ({
  title,
  order,
  element,
  handleSort,
  ...props
}: TableHeadCellProps) => {
  const isAscending = order === SortingOrder.Asc
  return (
    <TableCell {...props}>
      <Content>
        <Typography>{title}</Typography>
        {handleSort && order && (
          <IconButton
            onClick={() =>
              handleSort(isAscending ? SortingOrder.Desc : SortingOrder.Asc)
            }
          >
            <ArrowDropDown direction={isAscending ? 'up' : 'down'} />
          </IconButton>
        )}
        {!!element && element}
      </Content>
    </TableCell>
  )
}

export default Table
